import React from 'react'
import ContactCard from '../Components/ContactCard'

// Update title to register page view with analytics
import useDocumentTitle from '../Utilities/useDocumentTitle'

function Contact() {
  useDocumentTitle('Contact')
  const contactList = [
    {
      href: 'https://www.linkedin.com/in/jeffreyaheller/',
      icon: 'fab fa-linkedin fa-lg',
      text: 'jeffreyaheller'
    },
    {
      href: 'mailto:heller.jeffrey@gmail.com',
      icon: 'fas fa-envelope fa-lg',
      text: 'heller.jeffrey@gmail.com'
    },
    {
      href: 'https://github.com/Jheller11',
      icon: 'fab fa-github-square fa-lg',
      text: 'Jheller11'
    },
    {
      href: 'https://www.chess.com/member/jhell80',
      icon: 'fas fa-chess-knight fa-lg',
      text: 'jhell80'
    }
  ]
  let contacts = contactList.map((item, i) => {
    return <ContactCard key={i} props={item} />
  })
  return (
    <div className='container'>
      <h4 className='text-center'>Contact</h4>
      <div className='row my-4'>{contacts}</div>
    </div>
  )
}

export default Contact
